import { Checkbox, Form } from 'antd';

import { MessageInputWithFilesUpload } from '@app/components/MessageInputWithFilesUpload';
import { CommentReplyField } from '@app/components/Modals/BotDetailsModal/components/CommentReplyField';
import { InstagramButtons } from '@app/components/Modals/BotDetailsModal/components/InstagramButtons';
import { InstagramPublicationsField } from '@app/components/Modals/BotDetailsModal/components/InstagramPublicationsField';
import { KeywordGroupsField } from '@app/components/Modals/BotDetailsModal/components/KeywordGroupsField';
import { KeywordOverlapWarning } from '@app/components/Modals/BotDetailsModal/components/KeywordOverlapWarning';
import { SocialChannelFields } from '@app/components/Modals/BotDetailsModal/components/SocialChannelFields';
import type { OverlapCheckGateRef } from '@app/components/Modals/BotDetailsModal/types';

import type { FormInstance } from 'antd';
import type { BaseOptionType } from 'antd/es/select';

interface KeywordMessageRobotFieldsProps {
  form: FormInstance;
  messageSocialType: string | undefined;
  socialIntegrationTypeValue: number | string | null | undefined;
  filteredIntegrations: BaseOptionType[];
  handleChannelOptions: (fieldName: string) => void;
  showAiToggle?: boolean;
  // Id редактируемого робота для проверки пересечений, null — новый робот
  robotId: number | null;
  // Разрешение проверки пересечений: снимается при закрытии окна
  overlapCheckGateRef: OverlapCheckGateRef;
  // Номер открытия окна: сигнал нового открытия для проверки пересечений
  windowSessionId: number;
}

export const KeywordMessageRobotFields = ({
  form,
  messageSocialType,
  socialIntegrationTypeValue,
  filteredIntegrations,
  handleChannelOptions,
  showAiToggle = false,
  robotId,
  overlapCheckGateRef,
  windowSessionId,
}: KeywordMessageRobotFieldsProps) => {
  return (
    <>
      <KeywordGroupsField
        emptyHint="Если ни одной строки нет, робот отвечает на любое входящее сообщение."
        emptyWarning="Группы ключевых слов не добавлены. Робот будет отвечать на каждое входящее текстовое сообщение в выбранных этапах воронки."
      />

      <KeywordOverlapWarning
        robotId={robotId}
        overlapCheckGateRef={overlapCheckGateRef}
        windowSessionId={windowSessionId}
      />

      <InstagramPublicationsField socialIntegrationType={messageSocialType} />

      <MessageInputWithFilesUpload
        formInstance={form}
        socialType={messageSocialType}
        onChange={({ target: { value } }) => {
          form.setFieldsValue({ message: value });
        }}
        showAiToggle={showAiToggle}
      />

      <InstagramButtons socialType={messageSocialType} />

      <CommentReplyField socialType={messageSocialType} />

      <SocialChannelFields
        form={form}
        socialIntegrationTypeValue={socialIntegrationTypeValue}
        filteredIntegrations={filteredIntegrations}
        handleChannelOptions={handleChannelOptions}
        required={false}
        defaultChannelLabel="Любой канал"
      />

      <Form.Item name="isStopAfterFirstResponse" valuePropName="checked">
        <Checkbox>Останавливать робота после первого ответа</Checkbox>
      </Form.Item>
    </>
  );
};
